import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
// Constants

import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { exitImpersonation } from '@utils/miscellaneous/exitImpersonation';
/**
 * Displays impersonation 'lip' that is below the header.
 *
 * @param props impersonation details
 * @returns {*} HTML content.
 */
const { BROKER, ASSISTER, ASSISTERENROLLMENTENTITY } = ALL_USER_ROLES;

const Impersonation = props => {
    const { impersonation, impersonationDetails } = props;
    const dispatch = useDispatch();

    const handleExitImpersonation = (event) => {
        event.preventDefault();
        void exitImpersonation(dispatch, impersonationDetails.switchBackLink);
    };

    const getImpersonationUserDisplayInfo = () => {
        switch (impersonationDetails.role) {
            case BROKER:
                return <FormattedMessage id='impersonation.viewing.agent' values={{ name: impersonationDetails.name }}/>;
            case ASSISTER:
                return <FormattedMessage id='impersonation.viewing.assister' values={{ name: impersonationDetails.name }}/>;
            case ASSISTERENROLLMENTENTITY:
                return <FormattedMessage id='impersonation.viewing.entity' values={{ name: impersonationDetails.name }}/>;
            default:
                return <FormattedMessage id='impersonation.viewing' values={{ name: impersonationDetails.name }}/>;
        }
    };

    return (
        <Fragment>
            { impersonation && impersonationDetails && impersonationDetails.name &&
                <div id="impersonation" className="grid-row">
                    <div>
                        <p>
                            { getImpersonationUserDisplayInfo() }
                            <span>
                                <a
                                    href='#'
                                    className="usa-button gi-button gi-button__primary gi-button--small"
                                    onClick={handleExitImpersonation}
                                >
                                    <FormattedMessage id='common.my_account'/>
                                </a>
                            </span>
                        </p>
                    </div>
                </div>
            }
        </Fragment>

    );
};

export default Impersonation;
